import React from 'react';
import {Link} from 'react-router-dom';
import policy from '@/lib/shop-policy.json';
export default function MountSetupNote(){return <aside className="mount-setup-note" aria-label="Mount installation and use notice"><strong>Installation & use notice</strong><p>{policy.short_notice}</p><Link to="/shop/policies#gnss-responsibility">Setup Responsibilities & Product Terms ↗</Link></aside>}

